/**
 *
 * @param {string} currencyValue
 * @returns {string}
 * Format currency value into the following format: XXX,XXX.YY
 */
export default function formatCurrencyValue(currencyValue) {
  const value = currencyValue.match(/[\d.]+/gm)[0];
  const currencyMatches = currencyValue.match(/[^\d.\s]+/gm);
  const currency = currencyMatches == null ? '' : currencyMatches[0];
  return (
    currency +
    Number(value).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    })
  );
}

/**
 * Format currency value using native Intl.NumberFormat
 * @param {string|number} value - The numeric value (can be string or number)
 * @param {string} currencyCode - ISO 4217 currency code (VND, USD, EUR, etc.)
 * @param {string} [locale] - Optional locale (defaults to user's locale)
 * @returns {string} Formatted currency string with appropriate symbol
 */
export function formatCurrencyWithSymbol(value, currencyCode = 'USD', locale) {
  // Parse input to number, default to 0 if invalid
  const numericValue = !value ? 0 : +String(value).replace(/[^\d.-]/g, '') || 0;

  // Format with Intl.NumberFormat, fallback on error
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(numericValue);
  } catch {
    return `${currencyCode}${numericValue.toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    })}`;
  }
}
